import {MenuItemTitle, Wrapper} from "./styled";
import {
    CloseCircleFilled
} from '@ant-design/icons'
import {Popconfirm} from "antd";
import {IProject} from "../../../../models/project";
import {FC, useContext} from "react";
import {useDeleteProjectMutation} from "../../../../redux/slices/project";
import {defaultProject, ProjectContext} from "../../../../services/contexts";

interface IProps {
    project: IProject
}

const ProjectMenuItem: FC<IProps> = (props) => {
    const {project} = props;
    const [deleteProject] = useDeleteProjectMutation();
    const {selectedProject, setSelectedProject} = useContext(ProjectContext);

    const onDelete = async () => {
        try {
            await deleteProject(project?.id as string).unwrap();
            if (selectedProject?.id === project.id) {
                setSelectedProject(defaultProject);
            }
        } catch {
            // delete failed; keep selection unchanged
        }
    };

    return (
        <>
            <MenuItemTitle>{project.name}</MenuItemTitle>
            <Popconfirm
                placement='right'
                title={'Are you sure to delete this project'}
                description={'Delete the project'}
                okText='Yes'
                cancelText='No'
                onConfirm={onDelete}
            >
                <CloseCircleFilled
                    data-testid={`delete-chat-button-x`}
                    className={'action-icon'}
                    style={{float: 'right'}}
                />
            </Popconfirm>
        </>
    )
}

export default ProjectMenuItem;